"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paginationDictionary = void 0;
exports.paginationDictionary = {
    paginationRows: 'Rows per page',
    paginationPage: 'Page',
    paginationPageOf: 'of',
    paginationToPage: 'Go to page',
    paginationNext: 'Next',
    paginationPrevious: 'Previous',
};
